<template>
    <v-dialog v-model="showDialog.default" persistent max-width="500" class="px-5">
        <v-card>
            <v-toolbar flat dark color="primary">
                <v-toolbar-title> متن آماده</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-toolbar-items>
                    <v-btn icon dark @click="showDialog.default = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="pt-5">
                <v-autocomplete label="متن پیشفرض" @input="setDefaultText" chips deletable-chips item-text="title" :items="textDefault" :id="textDefault.id" prepend-inner-icon="fa fa-pencil-alt">

                    <template v-slot:item="data">
                        <v-list-item-content>

                            <v-list-item-title>
                                <span class="text-capitalize">{{ data.item.title }} - {{ data.item.category }}</span>
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                </v-autocomplete>

                <v-autocomplete label="آگهی پیشفرض" @input="setDefaultAdvertise" chips deletable-chips item-text="title" prepend-inner-icon="fa fa-pencil-alt" :items="advertiseDefault" :id="advertiseDefault.id">
                    <template v-slot:item="data">
                        <v-list-item-content>
                            <v-list-item-title>
                                <span class="text-capitalize">{{ data.item.title }}</span>
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                </v-autocomplete>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DefaultModal",
    props: {
        showDialog: {
            required: true,
        },
        advertise: {
            required: true
        }
    },
    data() {
        return {
            textDefault: [],
            advertiseDefault: [],
        }
    },
    methods: {
        getTextDefault() {
            $.ajax({
                url: `${url}/default/text/all`,
                method: "GET",
                fn: this.getTitles,
                headers: {
                    ACCEPT: 'application/json',
                    Authorization: Token,
                    "Content-Type": 'application/json'
                },
                success: (data) => {
                    this.textDefault = data;
                }
            });
        },
        getAdvertiseDefault() {
            $.ajax({
                url: `${url}/default/own/all`,
                method: "GET",
                fn: this.getTitles,
                headers: {
                    ACCEPT: 'application/json',
                    Authorization: Token,
                    "Content-Type": 'application/json'
                },
                success: (data) => {
                    this.advertiseDefault = data
                }
            })

        },
        setDefaultText(selected) {
            const defaultText = this.textDefault.find(item => item.title === selected);

            this.advertise.title = defaultText.title;
            this.advertise.description = defaultText.description;

            this.showDialog.default = false
        },
        setDefaultAdvertise(selected) {
            const defaultText = this.advertiseDefault.find(item => item.title === selected);

            this.advertise.title = defaultText.title;
            this.advertise.description = defaultText.description;

            this.showDialog.default = false
        }
    },
    mounted() {
        this.getTextDefault();
        this.getAdvertiseDefault();
    }
}
</script>

<style scoped>

</style>